/**
 * Tiny client-side event log. Buffers up to ~1000 events in Dexie;
 * the sync engine flushes them to /api/v1/field/events on each
 * successful sync (Phase 2.14 telemetry endpoint, Phase 4 wiring).
 */
import { getDb } from '../db';

const MAX_EVENTS = 1000;

export async function logEvent(type: string, payload?: unknown): Promise<void> {
  try {
    const db = getDb();
    await db.event_log.add({
      type,
      payload,
      created_at: Date.now(),
    });
    // Trim oldest if over cap.
    const count = await db.event_log.count();
    if (count > MAX_EVENTS) {
      const toDrop = count - MAX_EVENTS;
      const oldest = await db.event_log
        .orderBy('created_at')
        .limit(toDrop)
        .toArray();
      await db.event_log.bulkDelete(oldest.map((e) => e.id!).filter(Boolean));
    }
  } catch {
    // Logging must never break the app.
  }
}
